import SloganCarousel from "./slogan-carousel/SloganCarousel";
import Trending from "./trending/Trending";
import HowItWorks from "./how-it-works/HowItWorks";
import {useEffect} from "react";
import WhyGenie from "./why-genie/WhyGenie";
import {useAppDispatch} from "../../store";
import {getHomeContent} from "../../store/home/ActionCreators";
import PastWishes from "./past-wishes/PastWishes";

const Home = () => {
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(getHomeContent())
        // dispatch(getCategories({}))
    }, [dispatch])

    return (
        <>
            <SloganCarousel/>
            <HowItWorks/>
            <WhyGenie/>
            <Trending/>
            <PastWishes/>
            {/*<Partners />*/}
        </>
    )
}

export default Home
